import { FC, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { ItvHeader } from '../../../components/Itv/ItvHeader';
import { ItvTabsNav } from '../../../components/Itv/ItvTabsNav';
import { Footer } from '../../../components/Footer';
import { NavComponent } from '../../../components/Navigation/NavComponent';
import { useUserContext } from '../../../providers/UserProvider';
import { ItvSubNav } from '../../../components/Itv/ItvSubNav';
import { AvailableBrands, BRANDS } from '../../../components/Itv/types';
import { RootRedirect } from '../shared/RootRedirect';
import { ItvSubHeader } from '../../../components/Itv/ItvSubHeader';
import { useSubNav } from '../../../hooks/useMobileSubNav';
import './ItvMain.scss';

export type SubNav = { title: string; slug: string; img: string; extraQueryParams: string };

export const ItvMain: FC = () => {
  const { theme } = useUserContext();
  const { subNavigation, subNav, mobileSubNav } = useSubNav(theme as AvailableBrands);

  useEffect(() => {
    const body = document.body;

    if (!body) return;

    // Remove any existing theme classes
    body.classList.remove(BRANDS.BINGO, BRANDS.SPINS, BRANDS.PRIZES);
    // Add new theme class
    body.classList.add(theme);

    return () => {
      body.classList.remove(BRANDS.BINGO, BRANDS.SPINS, BRANDS.PRIZES);
    };
  }, [theme]);

  return (
    <div className={`itv-layout ${theme}`}>
      <RootRedirect />
      <ItvHeader />
      <div className="itv-layout__main">
        <div className="itv-layout__constant-header">
          {subNavigation && <ItvTabsNav subNavigation={subNavigation} />}
          <ItvSubHeader />
        </div>
        <NavComponent>
          <>
            {subNavigation && <ItvSubNav navItems={subNav} mobileNavItems={mobileSubNav} />}
            <div className="itv-layout__content">
              <Outlet />
            </div>
          </>
        </NavComponent>
      </div>

      <Footer isLangSwitcherDisplayed={false} isTimeDisplayed={false} />
    </div>
  );
};
